import React, { useState } from "react";
import { useTranslate } from "react-admin";
import { Box, ButtonBase, Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LaunchIcon from "@material-ui/icons/Launch";
import { createSessionTokenCustom } from "services/interface";
import { getAiFrontendUrl, persistAiAuthorization } from "services/aiSetting";
import SnackbarUtils from "utils/SnackbarUtils";

const useStyles = makeStyles({
  tabPanel: { width: "100%", margin: "0 20px", minWidth: 0 },
  menu: {
    display: "inline-flex",
    alignItems: "center",
    fontSize: 14,
    margin: 8,
    color: "inherit",
    textDecoration: "none",
  },
  launchIcon: { marginLeft: 8 },
});

const AISetting = ({ value, index }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const [opening, setOpening] = useState(false);

  const openAi = async () => {
    const tab = window.open("", "_blank");
    if (!tab) return;
    tab.opener = null;
    setOpening(true);
    try {
      const res = await createSessionTokenCustom(9999999);
      if (!res?.Authorization)
        throw new Error("Cannot create Carmen session token.");
      await persistAiAuthorization(res.Authorization);
      const baseURL = getAiFrontendUrl();
      const params = new URLSearchParams({
        token: res.Authorization,
        bu: localStorage.getItem("Tenant") || "",
        user: localStorage.getItem("UserName") || "",
        uri:
          window.location.origin === "http://localhost:3000"
            ? "https://dev.carmen4.com"
            : window.location.origin,
      });
      tab.location.href = `${baseURL}/#/CreditCardOCR/email-settings?${params}`;
    } catch (error) {
      tab.close();
      SnackbarUtils.error(error.message);
    } finally {
      setOpening(false);
    }
  };

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      className={classes.tabPanel}
    >
      {value === index && (
        <Box py={2}>
          <Typography variant="h6">{translate("ra.module.AI")}</Typography>
          <Box mt={1} mb={2}>
            <Typography variant="body2" color="textSecondary">
              {translate("ra.ai.websiteSettingsHint")}
            </Typography>
          </Box>
          <Divider />
          <Box mt={1}>
            <Typography
              component={ButtonBase}
              variant="h6"
              className={classes.menu}
              onClick={openAi}
              disabled={opening}
              focusRipple
            >
              {translate("ra.ai.title")}
              <LaunchIcon className={classes.launchIcon} />
            </Typography>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default AISetting;
